export const ReasonFormTestIds = {
  REASON_INPUT: 'reason-form.reason-input',
  SNAPDOCS_COMMENT_FORM: 'snapdocs-comment-prompt.form',
  SNAPDOCS_COMMENT_INPUT: 'snapdocs-comment-prompt.comment-input',
  SNAPDOCS_COMMENT_SUBMIT_BUTTON: 'snapdocs-comment-prompt.post-button',
  SNAPDOCS_OPT_OUT_FORM: 'snapdocs-opt-out-prompt.form',
  SNAPDOCS_OPT_OUT_REASON_INPUT: 'snapdocs-opt-out-prompt.reason-input',
  SNAPDOCS_OPT_OUT_SUBMIT_BUTTON: 'snapdocs-opt-out-prompt.opt-out-button',
};
